import { isChannel } from "@website/utils/channel/helpers";
import { allServices } from "@website/widget/header/hooks/constants";

export const useServices = () => {
  const services = isChannel(["SNAPP_AD", "ads", "snapp-ir"])
    ? allServices.filter((s) => ["/flights", "/inter-flights"].includes(s.url))
    : allServices;

  return {
    services
  };
};
